import { User } from "./types";
import { getUserName } from "./DataTransform";

/**
 * Natural, case-insensitive string comparison: "Student 2" sorts before
 * "Student 10", and case is ignored. The single source of truth for ordering
 * user/people/team lists across the app.
 */
export function naturalCompare(
  a: string | undefined | null,
  b: string | undefined | null,
): number {
  return (a || "").localeCompare(b || "", undefined, {
    numeric: true,
    sensitivity: "base",
  });
}

/**
 * Compare two users by their display name (firstName lastName), naturally.
 * Use as the default comparator wherever a list of users is shown.
 */
export function compareUsersByName(a: User, b: User): number {
  return naturalCompare(getUserName(a), getUserName(b));
}

/**
 * Return a new array of users sorted by display name, naturally.
 */
export function sortUsersByName<T extends User>(users: T[]): T[] {
  return [...users].sort(compareUsersByName);
}
